/* unplugin-vue-components disabled */import { render } from "./ResourceCard.vue?vue&type=template&id=df68ff08&scoped=true"
import script from "./ResourceCard.vue?vue&type=script&lang=js"
export * from "./ResourceCard.vue?vue&type=script&lang=js"

import "./ResourceCard.vue?vue&type=style&index=0&id=df68ff08&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户广西-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df68ff08"]])

export default __exports__